// extracted by mini-css-extract-plugin
export var quantityInput = "_gu-0";